<template>
  <v-card height="300" class="d-flex justify-center align-center">
    <lottie-player
      src="https://assets3.lottiefiles.com/private_files/lf30_xuz864r8.json"
      background="transparent"
      speed="1"
      style="width: 100px; height: 100px;"
      loop
      autoplay
    />
  </v-card>
</template>
<script>
export default {};
</script>
